export const RESOURCE_TYPE_SERVICEDESK_JSM_CONTEXT = 'SERVICEDESK_JSM_CONTEXT';
